var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertsHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M85 67v36m25.2 13L85 103m49.602-28.8 22.597 19.732 19.733-22.597"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M157 93c0-36.45-29.549-63-66-63-36.45 0-66 29.55-66 66 0 36.451 29.55 66 66 66h6.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D71B8",
    d: "M132.448 140.311a21.462 21.462 0 0 1 1.608-8.181 21.285 21.285 0 0 1 4.598-6.928 21.055 21.055 0 0 1 6.882-4.613 20.932 20.932 0 0 1 8.111-1.589c11.61.089 20.905 9.827 20.905 21.577v2.102c0 10.596 2.199 16.752 4.134 20.126a2.389 2.389 0 0 1 .002 2.365 2.37 2.37 0 0 1-.855.867 2.33 2.33 0 0 1-1.17.32h-46.326a2.33 2.33 0 0 1-1.17-.32 2.37 2.37 0 0 1-1.167-2.05c0-.415.109-.822.314-1.182 1.935-3.374 4.134-9.53 4.134-20.126v-2.368Z",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D71B8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M132.448 140.311a21.462 21.462 0 0 1 1.608-8.181 21.285 21.285 0 0 1 4.598-6.928 21.055 21.055 0 0 1 6.882-4.613 20.932 20.932 0 0 1 8.111-1.589c11.61.089 20.905 9.827 20.905 21.577v2.102c0 10.596 2.199 16.752 4.134 20.126a2.389 2.389 0 0 1 .002 2.365 2.37 2.37 0 0 1-.855.867 2.33 2.33 0 0 1-1.17.32h-46.326a2.33 2.33 0 0 1-1.17-.32 2.37 2.37 0 0 1-1.167-2.05c0-.415.109-.822.314-1.182 1.935-3.374 4.134-9.53 4.134-20.126v-2.368Zm11.338 26.046v2.429a9.714 9.714 0 1 0 19.428 0v-2.429"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsHistory);
export default __webpack_public_path__ + "static/media/AlertsHistory.ff99211e2fd79006d8c0541a4e01806a.svg";
export { ForwardRef as ReactComponent };